// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__K3Fjs","nav":"Tabs_nav__SLum5"};